import {
  isCustomerDetailRoute,
  isCustomerEditRoute,
  isTeamDetailRoute,
  isTeamEditRoute,
  isAgentDetailRoute,
  isAgentEditRoute,
  isGroupDetailRoute,
  getPeopleInlineHeaderMeta,
} from "./peopleHelpers";

/**
 * Page title shown next to the sidebar toggle in DashboardHeader (Application V2).
 * Returns null when the header should not show an inline title (e.g. people detail/back).
 */
export function getDashboardInlineHeaderTitle(pathname) {
  if (!pathname) return null;

  if (
    isCustomerDetailRoute(pathname) ||
    isCustomerEditRoute(pathname) ||
    isTeamDetailRoute(pathname) ||
    isTeamEditRoute(pathname) ||
    isAgentDetailRoute(pathname) ||
    isAgentEditRoute(pathname) ||
    isGroupDetailRoute(pathname)
  ) {
    return null;
  }

  const peopleMeta = getPeopleInlineHeaderMeta(pathname);
  if (peopleMeta?.title) return peopleMeta.title;

  if (/\/settings\/(personal|admin)(\/|$)/.test(pathname)) {
    return "Settings";
  }

  if (pathname === "/dashboard" || pathname.startsWith("/dashboard/")) {
    return "Overview";
  }
  if (pathname === "/notifications" || pathname.startsWith("/notifications/")) {
    return "Notifications";
  }
  if (pathname === "/Live" || pathname.startsWith("/Live/")) {
    return "Live Chat";
  }
  if (
    pathname === "/tickets" ||
    pathname.startsWith("/tickets/") ||
    pathname === "/ticketsection" ||
    pathname.startsWith("/ticketsection/")
  ) {
    return "Tickets";
  }
  if (pathname === "/user-traffic" || pathname.startsWith("/user-traffic/")) {
    return "Traffic";
  }
  if (
    pathname === "/teamsection" ||
    pathname.startsWith("/teamsection/") ||
    pathname.includes("/groupupdate/") ||
    pathname.includes("/userupdate/")
  ) {
    return "Team";
  }
  if (pathname === "/search" || pathname.startsWith("/search/")) {
    return "Search";
  }

  if (pathname.startsWith("/kb/article/")) {
    return null;
  }
  if (pathname.startsWith("/kb/overview")) return "Knowledge Base";
  if (pathname.startsWith("/kb/articles")) return "Articles";
  if (pathname.startsWith("/kb/categories")) return "Categories";
  if (pathname.startsWith("/kb/review-queue")) return "Review Queue";
  if (pathname.startsWith("/kb/feedback-queue")) return "Feedback Queue";
  if (pathname.startsWith("/kb/customization")) return "Customization";

  if (pathname.startsWith("/analytics/overview")) return "Overview";
  if (pathname.startsWith("/analytics/chats")) return "Chats";
  if (pathname.startsWith("/analytics/tickets")) return "Tickets";
  if (pathname.startsWith("/analytics/agents")) return "Agents";
  if (pathname.startsWith("/analytics/knowledgeBase")) return "Knowledge Base";
  if (pathname.startsWith("/analytics/data-export")) return "Export & Reports";

  if (pathname.startsWith("/settings/")) return "Settings";

  return null;
}

/**
 * Whether DashboardHeader should render the group selector (Application V2).
 * Ticket V2 keeps its own group control in the tickets sidebar.
 */
export function shouldShowHeaderGroupSelect(pathname) {
  if (!pathname) return false;

  if (
    isCustomerDetailRoute(pathname) ||
    isCustomerEditRoute(pathname) ||
    isTeamDetailRoute(pathname) ||
    isTeamEditRoute(pathname) ||
    isAgentDetailRoute(pathname) ||
    isAgentEditRoute(pathname) ||
    isGroupDetailRoute(pathname)
  ) {
    return false;
  }

  const peopleMeta = getPeopleInlineHeaderMeta(pathname);
  if (
    peopleMeta?.title === "Customers" ||
    peopleMeta?.title === "Teams" ||
    peopleMeta?.title === "Agents"
  ) {
    return true;
  }

  if (pathname === "/dashboard" || pathname.startsWith("/dashboard/")) {
    return true;
  }
  if (pathname === "/user-traffic" || pathname.startsWith("/user-traffic/")) {
    return true;
  }
  if (
    pathname.startsWith("/kb/overview") ||
    pathname.startsWith("/kb/articles") ||
    pathname.startsWith("/kb/categories") ||
    pathname.startsWith("/kb/review-queue") ||
    pathname.startsWith("/kb/feedback-queue") ||
    pathname.startsWith("/kb/customization")
  ) {
    return true;
  }
  if (pathname.startsWith("/analytics/")) {
    return true;
  }

  return false;
}
